<div class="flex h-screen overflow-hidden">
  <app-sidebar></app-sidebar>

  <div class="flex-1 flex flex-col overflow-hidden">
    <app-header></app-header>

    <main class="flex-1 overflow-x-hidden overflow-y-auto p-6 bg-gray-100">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
